export default __webpack_public_path__ + "3d84a1ec7364323dd9e37b1eaf89e9b7.png";